export default __webpack_public_path__ + "static/media/Wanda.a6646769.png";